import { render, staticRenderFns } from "./historyData.vue?vue&type=template&id=9785d95c&"
import script from "./historyData.vue?vue&type=script&lang=js&"
export * from "./historyData.vue?vue&type=script&lang=js&"
import style0 from "./historyData.vue?vue&type=style&index=0&id=9785d95c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports